// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"NewVersionModal_Overlay__2ruhv","Popup":"NewVersionModal_Popup__2ODx2"};